<template>
  <div class="warp">
    <div class="cententbox" ref="pageh">
      <!--搜索-->
      <div class="search-area" ref="pagehcf">
        <div class="flexspantt">
          <span class="baack-empty" @click="backbtn">返回</span>
        </div>
        <div class="search-area-left">
          <div class="search-area-item">
            <span class="titlt">巡更点名称</span>
            <el-input
              v-model.trim="keyword"
              placeholder=""
              maxlength="50"
              clearable
              class="inputwid160"
            ></el-input>
          </div>
          <div class="btn" @click="searchPlan">搜索</div>
        </div>
      </div>

      <div class="publicTable">
        <el-table
          :data="tableData"
          height="100%"
          border
          empty-text
          style="width: 100%"
          :cellStyle="{
            padding: '4px',
            fontSize: '14px',
            textAlign: 'center',
            color: '#000',
          }"
        >
          <el-table-column
            prop="pointName"
            label="巡更点名称"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span>{{
                scope.row.type == 1
                  ? "定位"
                  : scope.row.type == 2
                  ? "NFC"
                  : "蓝牙"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="username"
            label="巡更用户"
            :show-overflow-tooltip="true"
            width="250"
          >
          </el-table-column>
          <el-table-column label="执行结果">
            <template slot-scope="scope">
              <span v-if="scope.row.state != null">{{
                scope.row.state == 0
                  ? "未开始"
                  : scope.row.state == 1
                  ? "进行中"
                  : scope.row.state == 2
                  ? "已完成"
                  : "漏巡"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="patrolTime" label="巡更时间" width="250">
          </el-table-column>
          <el-table-column label="上传图片" width="250">
            <template slot-scope="scope">
              <div
                v-if="scope.row.imgUrl"
                style="display:flex;align-items:center;justify-content:center"
              >
                <el-image
                  style="width: 50px; height: 50px"
                  fit="cover"
                  :src="xinPatrolApi + scope.row.imgUrl"
                  :preview-src-list="[xinPatrolApi + scope.row.imgUrl]"
                >
                </el-image
                ><el-button
                  type="text"
                  style="padding:5px 10px;margin-left:10px"
                  @click="
                    downloadImage(xinPatrolApi + scope.row.imgUrl, 'member')
                  "
                  >下载</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="人脸识别结果">
            <template slot-scope="scope">
              <span class="textcolor" v-if="scope.row.faceResult != null"
                >{{ scope.row.faceResult == 0 ? "失败" : "成功" }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <div class="flexcl">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[20, 40, 60, 80]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper , slot, sizes"
          :total="total"
        >
          <span class="confirbtn">确定</span>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { ChangeDateFormatwo, downloadImage } from "@/method/utils.js";
import beasconfig from "@/api/beasconfig.js";
const xinPatrolApi = beasconfig.xinPatrolApi;
export default {
  name: "performTsksDetails",
  data() {
    return {
      taskId: "",
      keyword: "",
      tableData: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      regex: /^[\u4e00-\u9fa5a-zA-Z0-9\s\S]{1,50}$/,
      xinPatrolApi: xinPatrolApi, //在table中使用，必须声明变量，不可直接用全局变量 xinPatrolApi
    };
  },
  created() {
    this.taskId = this.$route.query.id;
    this.searchPlan();
  },
  mounted() {},
  methods: {
    //搜索
    searchPlan() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        taskId: this.taskId,
        keyword: this.keyword,
      };
      axios
        .get(xinPatrolApi + "/api/task/details", {
          params: { ...params },
          headers: {
            key: this.$store.state.userInfo.User_ID, 
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.list;
            this.tableData.forEach((item) => {
              if (item.patrolTime) {
                item.patrolTime = ChangeDateFormatwo(item.patrolTime, true);
              }
            });
            this.total = res.data.data.total;
          }
        });
    },

    //图片下载
    downloadImage(imgsrc, name) {
      downloadImage(imgsrc, name);
    },

    //返回
    backbtn() {
      // this.planName = "";
      this.$router.go(-1);
    },

    //分页器
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.searchPlan();
    },
    //分页器
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.searchPlan();
    },
  },
};
</script>
<style lang="less" scoped>
.warp {
  min-width: 900px;
  height: 100%;
  .cententbox {
    padding: 10px;
    height: calc(100% - 20px);
    background-color: #ffffff;
    .persontextbox {
      height: 42px;
      border-bottom: 1px solid #ddd;
      .persontext {
        display: inline-block;
        height: 41px;
        line-height: 41px;
        padding: 0 20px;
        font-size: 15px;
        color: #888;
        border: 1px solid #ddd;
        border-bottom-color: #fff;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        background-color: #fff;
      }
    }

    .disflex {
      display: flex;
      flex-direction: row;
    }

    .disflexc {
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
    }

    .flexspan {
      justify-content: space-between;
    }

    .flexdivcl {
      justify-content: space-around;
    }

    .flexal {
      align-items: center;
      // margin:10px;
    }

    .divwidcl {
      width: 80%;
    }

    .heaedercl {
      justify-content: space-between;
      background: #f0f0f0;
      margin: 10px 0;
      padding: 10px;
    }

    .inputwid200 {
      width: 180px;
    }

    .inputwid140 {
      width: 150px;
    }

    .marright {
      margin-right: 5px;
    }

    .inputwid160 {
      width: 208px;
    }

    .inputwid120 {
      width: 180px;
    }

    .spancl {
      display: block;
    }

    .excelcl {
      position: absolute;
      bottom: 20px;
    }

    .spanrightcl {
      margin-right: 10px;
    }

    .changeagentcl {
      display: inline-block;
      /* background-color: #002FA7; */
      padding: 10px 20px;
      /* color: #ffffff; */
      border-radius: 5px;
      cursor: pointer;
      margin-left: 10px;
    }

    // /deep/.el-input__inner:focus {
    //   border-color: #002fa7;
    // }

    .secondcl {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 80px;
      margin-top: 10px;
    }

    .search-area {
      display: flex;
      /*align-items: center;*/
      justify-content: space-between;
      padding: 10px;
      margin: 0 0 10px;
      background: #f0f0f0;
      // min-width: 1010px;
      .search-area-left {
        // width: 100%;
        display: flex;
        &:after {
          content: "";
          height: 0;
          clear: both;
          visibility: hidden;
          display: block;
        }
        .btn {
          cursor: pointer;
          color: #fff;
          height: 38px;
          width: 70px;
          background: #5a5657;
          line-height: 38px;
          text-align: center;
          border-radius: 4px;
        }
        .search-area-item {
          margin-right: 30px;
          display: flex;
          align-items: center;
          .titlt {
            margin-right: 10px;
            min-width: 60px;
          }
        }
      }
      .baack-empty {
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: #5a5657;
        border-color: #fff;
        display: inline-block;
        cursor: pointer;
        margin-right: 20px;
        min-width: 28px;
      }
    }
  }
}
.publicTable {
  height: calc(100% - 42px - 70px);
  /deep/.el-table {
    background-color: #ffffff !important;
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
    }
    & th > .cell {
      text-align: center;
      color: #000000;
      font-weight: bold;
    }
    .textcolor {
      cursor: pointer;
    }
  }
}
.flexcl {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  /deep/.el-pagination {
    .el-pagination__jump {
      margin-left: 0;
    }
    .confirbtn {
      background-color: #5a5657;
      padding: 0 6px;
      color: #ffffff;
      margin-left: 4px;
      cursor: pointer;
      border-radius: 2px;
      // line-height: 14px;
    }
  }
}
.red {
  color: red;
}
</style>
